
const config = {
	// BASE_URL:"http://192.168.1.4:8060",
	// BASE_URL: "http://49.232.119.48:8080",  //基础路径
	BASE_URL: "https://www.hebotc.com",  //基础路径

};

export default config



//////////////////
// WEBPACK FOOTER
// ./base/config.js
// module id = null
// module chunks = 